import { render, staticRenderFns } from "./UnidadeNegocioProfile.vue?vue&type=template&id=74cb284a"
import script from "./UnidadeNegocioProfile.vue?vue&type=script&lang=js"
export * from "./UnidadeNegocioProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports